import { GridCell, GridCellProps, useGridApiContext } from '@mui/x-data-grid';
import React from 'react';

interface Props extends GridCellProps {
  idPrefix?: string;
}

const GridCellWithId: React.FC<Props> = ({ idPrefix, ...rest }) => {
  const apiRef = useGridApiContext();
  const rowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(rest.rowId);

  return <GridCell {...rest} id={`${idPrefix ?? ''}row-${rowIndex}-${rest.column.field}`} />;
};

export default GridCellWithId;
